<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-img
          src="/static/logo.png"
          class="my-3"
          contain
          height="300"
        />
      </v-col>

      <v-col class="mb-4">
        <h1 class="display-2 mb-3">
          Próg do Challengera: <span class="font-weight-bold">{{ threshold_info.chall_threshold }} LP</span>
        </h1>

        <p class="subheading font-weight-regular">
          Last updated {{ lastUpdated }} ago
        </p>
      </v-col>
      <v-col class="mb-4">
        <h1 class="display-2 mb-3">
          Próg do GrandMastera: <span class="font-weight-bold">{{ threshold_info.gm_threshold }} LP</span>
        </h1>

        <p class="subheading font-weight-regular">
          Last updated {{ lastUpdated }} ago
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import axios from 'axios';
  import moment from 'moment';
  export default {
    name: 'FlexCutoff',

    data: () => ({
      threshold_info: {
        gm_threshold: 0,
        chall_threshold: 0,
        last_updated: null,
      },
    }),
    async mounted() {
      await axios.get('/api/threshold/').then(response => this.threshold_info = response.data);
    },
    computed: {
      lastUpdated() {
        return moment(this.threshold_info.last_updated).fromNow(true);
      }
    }
  }
</script>
